/**
 * Application layout shell.
 * Renders a sticky three-region header (brand, title, nav) above
 * a scrollable content area.
 *
 * @module components/Layout
 */

import React       from 'react';
import HeaderBrand from './HeaderBrand';
import HeaderTitle from './HeaderTitle';
import HeaderNav   from './HeaderNav';

/**
 * Wraps page content with the application header.
 *
 * @param {object} props
 * @param {string} props.title      - The page title shown in the header.
 * @param {React.ReactNode} props.children - Page content.
 * @returns {React.ReactElement}
 */
export default function Layout({ title, children }) {
  return (
    <div className="app-layout">
      <header className="app-header">
        <HeaderBrand />
        <HeaderTitle title={title} />
        <HeaderNav />
      </header>
      <main className="app-content">
        {children}
      </main>
    </div>
  );
}
